const MAX_LENGTH_INPUT = 120;

export const FIELD_NAME = {
  SERVICE_TYPE: 'SERVICE_TYPE',
  PROMO: 'PROMO',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  PARTNER_ORDER_ID: 'PARTNER_ORDER_ID',
  ITEM_WEIGHT: 'ITEM_WEIGHT',
  ITEM_TYPE: 'ITEM_TYPE',
  INSTRUCTION: 'INSTRUCTION',
  REFERENCE_CODE: 'REFERENCE_CODE',
};

export const PERSON_REQUIRED_FIELDS = ['name', 'phone'];

export const MODE = {
  HOME: 'HOME',
  SINGLE_BOOK: 'SINGLE_BOOK',
  MULTI_BOOK: 'MULTI_BOOK',
  BULK_UPLOAD: 'BULK_UPLOAD',
};

export const FORM_FIELD_OPTIONS = {
  [FIELD_NAME.INSTRUCTION]: {
    rules: [
      {
        max: MAX_LENGTH_INPUT,
        message: `Instructions cannot be longer then ${MAX_LENGTH_INPUT} characters`,
      },
    ],
  },
  [FIELD_NAME.PROMO]: {
    rules: [
      {
        max: MAX_LENGTH_INPUT,
        message: `Promo cannot be longer then ${MAX_LENGTH_INPUT} characters`,
      },
    ],
  },
  [FIELD_NAME.REFERENCE_CODE]: {
    rules: [
      {
        max: MAX_LENGTH_INPUT,
        message: `Reference code cannot be longer then ${MAX_LENGTH_INPUT} characters`,
      },
    ],
  },
  [FIELD_NAME.ITEM_WEIGHT]: {
    rules: [{ required: true, type: 'number', min: 0 }],
    getValueFromEvent: e => {
      const value = Number(e.currentTarget.value);
      return isNaN(value) ? Number(value) : value;
    },
  },
};
